import constant from "../../constant";
import axios from "axios";
import router from "../../router";

const api = constant.api + "shares";

const state = () => ({
  all: [],
  shares: [],
  share: {},
});

// =====================
// GETTERS
// =====================
const getters = {
  getAll: (state) => state.all,
  getShares: (state) => state.shares,
  getShare: (state) => state.share,
};

// =====================
// ACTIONS
// =====================
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      const shares = response.data;
      commit("setShares", shares);
    });
  },

  async show({ commit }, id) {
    await axios.get(`${api}/${id}`).then((response) => {
      const share = response.data;
      commit("setShare", share);
    });
  },

  async store({ dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      const status = response.data.status;
      const message = response.data.message;

      dispatch("notification/store", { status, message }, { root: true });

     
    });
  },

  async destroy({ commit, dispatch }, id) {
    await this.$api.delete(`${api}/${id}`).then((response) => {
      const message = response.data.message;
      const status = response.data.status;
      const shares = response.data.data;

      dispatch("notification/store", { status, message }, { root: true });

      if (status === "success") {
        commit("setShares", shares);
      }
    });
  },
};

// =====================
// MUTATIONS
// =====================
const mutations = {
  setShares(state, shares) {
    state.all = shares;
    state.shares = shares;
  },
  setShare(state, share) {
    state.share = share;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
